import React from 'react'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import moment from 'moment-jalaali'
import { toPersianDigit } from './nums'
import settings from '../settings'
import { NotificationManager } from 'react-notifications'

export function isEmptyObject(obj) {
  if (obj) {
    return Object.keys(obj).length === 0
  } else {
    throw new Error('isEmptyObject Expects an object')
  }
}

export function storeLocally(key, value) {
  return localStorage.setItem(key, value)
}

export function readLocally(key) {
  return localStorage.getItem(key)
}

export function removeLocally(key) {
  return localStorage.removeItem(key)
}

export function storeSession(key, value) {
  return sessionStorage.setItem(key, value)
}

export function readSession(key) {
  return sessionStorage.getItem(key)
}

export function removeSession(key) {
  return sessionStorage.removeItem(key)
}

export function clearSession() {
  return sessionStorage.clear()
}

export function sessionToLocalStorage(key) {
  const session = readSession(key)
  return storeLocally(key, session)
}

export function localToSessionStorage(key) {
  const local = readLocally(key)
  return storeSession(key, local)
}

export function appendToFormData(values, options) {
  let formData = new FormData()

  for (let field in values) {
    if (options && options.acceptNull) {
      if (values[field] !== undefined) {
        formData.append(field, values[field])
      }
    } else {
      if (values[field] !== undefined && values[field] !== null) {
        formData.append(field, values[field])
      }
    }
  }

  return formData
}

export function logFormData(formData) {
  if (process.env.NODE_ENV === 'development') {
    for (let pair of formData.entries()) {
      console.log(pair[0] + '  =>  ' + pair[1])
    }
  }
}

export function convertErrorsToString(form_errors) {
  let new_form_errors = {}
  for (let field of Object.keys(form_errors)) {
    if (form_errors[field] instanceof Array) {
      new_form_errors[field] = form_errors[field].join(' ')
    } else {
      new_form_errors[field] = form_errors[field]
    }
  }
  return new_form_errors
}

export function getUserType(userObject) {
  if (userObject.user_type) {
    return userObject.user_type.toUpperCase()
  } else {
    return undefined
  }
}

export function getFileExtension(filename) {
  if (typeof filename === 'string') {
    return filename.split('.').pop()
  } else {
    return ''
  }
}

const dictionary = {
  true: 'بله',
  false: 'خیر',
  username: 'نام کاربری',
  first_name: 'نام',
  city_name: 'شهر',
  last_name: 'نام خانوادگی',
  email: 'ایمیل',
  phone_number: 'شماره موبایل',
  secondary_phone: 'شماره تماس دوم',
  info: 'توضیحات',
  address: 'نشانی',
  avatar: 'عکس',
  change_password: 'تغییر گذرواژه ',
  gender: 'جنسیت',
  male: 'پسر',
  female: 'دختر',
  school: 'مرکز آموزشی',
  national_number: 'شماره ملی',
  Region: 'منطقه',
  grade_name: 'مقطع تحصیلی',
  schools: 'مدارس',
  boy: 'پسرانه',
  girl: 'دخترانه',
  both: 'مشترک',
  title: 'عنوان',
  status: 'وضعیت',
  description: 'توضیحات',
  owner_name: 'نام ثبت کننده',
  owner_phone_number: 'شماره موبایل ثبت کننده',
  owner_email: 'ایمیل ثبت کننده',
  expiration_date: 'تاریخ اعتبار',
  verified: 'تایید شده',
  school_type: 'نوع مدرسه',
  gender_group: 'جنسیت دانش آموزان',
  application_accesses: 'دسترسی های اپلیکشن',
  price: 'هزینه',
  register_date: 'شروع ثبت نام',
  host_students_count: 'حداقل دانش آموزان حوزه',
  host_off_amount: 'درصد تخفیف حوزه',
  event_date: 'تاریخ رویداد',
  verified_email: 'ایمیل تایید شده',
  register_end_date: 'پایان ثبت نام',
  event_end_date: 'پایان آزمون',
  verified_phone: 'شماره موبایل تایید شده',
  hard: 'سخت',
  easy: 'آسان',
  normal: 'معمولی',
  event_duration_minutes: 'طول مدت آزمون',
  result_date: 'تاریخ اعلام نتایج',
  type: 'نوع',
  completed: 'انجام شده',
  pending: 'پرداخت نشده',
  active: 'فعال',
  total_orders: 'تعداد سفارش‌ها در مجموع',
  bought_orders: 'تعداد سفارش‌ها پرداخت شده',
  total_tickets: 'تعداد آزمون های شرکت کرده',
  spent: 'مبلغ خرید ها در سامانه (تومان)',
  total_course_orders: 'تعداد دوره های آموزشی خریداری شده',
  app_url: 'لینک نرم افزار',
  event: 'رویداد',
  state: 'دولتی',
  private: 'غیر دولتی',
  trustees: 'هیات امنایی',
  special: 'نمونه دولتی',
  shahed: 'شاهد',
  boarding: 'شبانه روزی',
  nodet: 'استعداهای درخشان',
  abroad: 'خارج از کشور',
  school_name: 'نام مرکز آموزشی',
  district_name: 'منطقه',
  dates_description: 'توضیحات تاریخ رویداد',
  has_agent: 'دارای نماینده',
  agent_share: 'سهم نماینده',
  approval_criteria_percent: 'معیار انتخاب برگزیدگان',
  approval_criteria_per_province: 'محاسبه برگزیدگان بر حسب استان',
  appreciation_letter_criteria_percent: 'معیار انتخاب تقدیر شوندگان',
  appreciation_letter_criteria_per_province: 'محاسبه تقدیر شوندگان بر اساس استان',
}

export function translateProfileFields(item, key) {
  if (key && key.includes('date')) {
    // make sure it is a string
    const momentObj = moment(item.toString())

    // the key might contain "date" but it might not be a real date
    if (!momentObj.isValid()) return item

    const hour = momentObj.format('LT')
    const date = momentObj.format('LL')
    return toPersianDigit(`${hour} - ${date}`)
  }

  if (key && key.includes('price')) {
    return item > 0 ? toPersianDigit(formattedPrice(item)) + ' تومان' : 'رایگان'
  }

  if (key && key.includes('host_students_count')) {
    return toPersianDigit(item)
  }

  if (key && key.includes('host_off_amount')) {
    return toPersianDigit(item)
  }

  if (key && key.includes('minutes')) {
    return toPersianDigit(item) + ' دقیقه'
  }

  if (item in dictionary) {
    return dictionary[item]
  } else {
    return item
  }
}

const excludedFields = [
  'city',
  'state',
  'user_type',
  'documents',
  'id',
  'code',
  'grade',
  'avatar',
  'thumbnail',
  'cover',
  'address',
  'event_type',
  'is_super_app',
  'access_levels',
  'ticket_order_description',
  'pending_orders',
  'school_source',
  'school_id',
  'district',
  'favorites',
]

export function filterNonNecessaryField(item) {
  if (excludedFields.includes(item)) {
    return false
  } else {
    return true
  }
}

export function parseErrors(generalErrors, formErrors) {
  let intKeys = Object.keys(formErrors).filter(key => !isNaN(parseInt(key, 10)))
  let errorText = ''
  for (let i = 0; i < intKeys.length; i++) {
    errorText += formErrors[intKeys[i]]
  }
  for (let i = 0; i < generalErrors.length; i++) {
    errorText += generalErrors[i]
  }
  return errorText
}

export function formattedPrice(price) {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const Price = ({ children, literalZero, ...rest }) => {
  children = children.toString()

  if (children === '0' && !literalZero) {
    return <span style={{ fontWeight: 600, color: 'green' }}>رایگان</span>
  }

  return (
    <span {...rest}>
      <span>{toPersianDigit(formattedPrice(children))}</span>
      <span>{' تومان'}</span>
    </span>
  )
}

export const Credit = ({ children }) => {
  children = children.toString()
  return (
    <span style={{ color: '#383de4', fontSize: 16 }}>
      <span>{toPersianDigit(formattedPrice(children))}</span>
      <span>{' تومان'}</span>
    </span>
  )
}

export const PersianDate = ({ children: dateString, noHour }) => {
  if (!dateString) {
    return <span>تعیین نشده</span>
  } else {
    dateString = dateString.toString() //make sure it is a string
    const hour = moment.utc(dateString).local().format('LT')
    const date = moment.utc(dateString).local().format('LL')
    if (noHour) {
      return <span>{toPersianDigit(`${date}`)}</span>
    }
    return <span>{toPersianDigit(`${hour} - ${date}`)}</span>
  }
}

export const toPersianDate = dateString => {
  return toPersianDigit(moment.utc(dateString).local().format('jM/jD'))
}

export function mapObjectToHtmlTable(object) {
  if (!object) {
    return <div />
  }
  const styles = {
    table: {
      width: '100%',
      fontFamily: 'IranYekanRegular',
      tableLayout: 'auto',
    },
    column: {
      textAlign: 'right',
      whiteSpace: 'pre-wrap',
    },
  }
  //react can not render objects !
  const keys = Object.keys(object).filter(key => typeof object[key] !== 'object')

  return (
    <Table selectable={false} style={styles.table} fixedHeader={false}>
      {/*<TableHeader>
        <TableRow>
          {keys.map(key => <TableHeaderColumn>{key}</TableHeaderColumn>)}
        </TableRow>
      </TableHeader>*/}
      <TableBody displayRowCheckbox={false}>
        {keys.filter(filterNonNecessaryField).map(key => {
          return (
            <TableRow hoverable={true} key={key} selectable={false}>
              <TableRowColumn style={styles.column}>
                {translateProfileFields(key)}
              </TableRowColumn>
              <TableRowColumn style={styles.column}>
                {translateProfileFields(object[key], key)}
              </TableRowColumn>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export function mapObjectToHtmlTableWithMarkup(object, title) {
  if (!object) {
    return <div />
  }

  const styles = {
    wrapper: {
      borderRadius: 10,
      padding: 10,
      boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'white',
    },
    table: {
      width: '100%',
      fontFamily: 'IranYekanRegular',
      tableLayout: 'auto',
    },
    column: {
      textAlign: 'right',
      whiteSpace: 'pre-wrap',
    },
  }

  //react can not render objects !
  const keys = Object.keys(object).filter(key => typeof object[key] !== 'object')

  return (
    <div style={styles.wrapper}>
      {title && <h4 style={{ textAlign: 'center' }}>{title}</h4>}

      <Table selectable={false} style={styles.table} fixedHeader={false}>
        <TableBody displayRowCheckbox={false}>
          {keys.filter(filterNonNecessaryField).map(key => {
            return (
              <TableRow hoverable={true} key={key} selectable={false}>
                <TableRowColumn style={{ ...styles.column, columnSpan: 2 }}>
                  {translateProfileFields(key)}
                </TableRowColumn>
                <TableRowColumn style={{ ...styles.column, columnSpan: 6 }}>
                  <div
                    className="foreign-markup"
                    dangerouslySetInnerHTML={{
                      __html: translateProfileFields(object[key], key),
                    }}
                  />
                </TableRowColumn>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}

export function isResponseSuccessful(status, formErrors, generalErrors) {
  return (
    status >= 200 &&
    status < 300 &&
    isEmptyObject(formErrors) &&
    generalErrors.length === 0
  )
}

export function isSameUser(profile1, profile2) {
  const { id1, userType1 } = profile1
  const { id2, userType2 } = profile2
  if (
    parseInt(id1, 10) === parseInt(id2, 10) &&
    userType1.toUpperCase() === userType2.toUpperCase()
  ) {
    return true
  }
  return false
}

export function statusCodeIsBelow400(status) {
  return status >= 200 && status < 400
}

export const getErrors = errors => {
  let errorsArray = []

  // new implementation:
  const iterator = errors => {
    for (let property in errors) {
      if (errors.hasOwnProperty(property)) {
        if (typeof errors[property] === 'object') iterator(errors[property])
        else errorsArray.push(errors[property])
      }
    }
  }

  iterator(errors)

  return errorsArray.map(item => toPersianDigit(item))
}

export const flattenArray = list =>
  list
    .reduce((a, b) => a.concat(Array.isArray(b) ? flattenArray(b) : b), [])
    .map(item => toPersianDigit(item))

export const thousandSeparator = number =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const createFormFromObject = (formFields, postUrl) => {
  var form = document.createElement('form')
  form.method = 'POST'
  form.action = postUrl

  for (let field in formFields) {
    if (formFields.hasOwnProperty(field)) {
      let element = document.createElement('input')
      element.value = formFields[field]
      element.name = field
      form.appendChild(element)
    }
  }
  return form
}

export const prependQuery = query => {
  if (query) {
    return `?${query}`
  } else {
    return ''
  }
}

export function submitFailure(fieldList) {
  return errors => {
    // Field Error(s). We need to step through fieldList to guarantee ordering (since redux-form returns an errors object, not array or map)
    if (errors) {
      fieldList.find(field => {
        if (errors[field]) {
          document.querySelector(`textarea[name=${field}]`).focus()
          return true
        }
        return false
      })
    }
  }
}

const covertToPersianDate = dateString => {
  const hour = moment(dateString).format('LT')
  const date = moment(dateString).format('LL')
  return toPersianDigit(`${hour} - ${date}`)
}

export const generateEventDate = (startDate, endDate) => {
  if (startDate && endDate) {
    if (moment(startDate).isSame(endDate, 'day')) {
      const startTime = moment(startDate).format('LT')
      const endTime = moment(endDate).format('LT')
      return toPersianDigit(
        `${moment(startDate).format('LL')} - ${startTime} الی ${endTime}`
      )
    } else {
      return covertToPersianDate(startDate) + ' الی ' + covertToPersianDate(endDate)
    }
  } else if (startDate && !endDate) {
    return covertToPersianDate(startDate)
  } else {
    return ''
  }
}

// Persian Wordifier
// Version: 1.0
// Author: Salman Arab Ameri
// Publish: 2014-03-11
// with use of ideas in http://www.dotnettips.info/post/626/%D8%AA%D8%A8%D8%AF%DB%8C%D9%84-%D8%B9%D8%AF%D8%AF-%D8%A8%D9%87-%D8%AD%D8%B1%D9%88%D9%81

export function wordifyfa(num, level) {
  if (num === null) {
    return ''
  }
  // convert negative number to positive and get wordify value
  if (num < 0) {
    num *= -1
    return 'منفی ' + wordifyfa(num, level)
  }
  if (num === 0) {
    if (level === 0) {
      return 'صفر'
    } else {
      return ''
    }
  }
  var result = '',
    yekan = ['یک ', 'دو ', 'سه ', 'چهار ', 'پنج ', 'شش ', 'هفت ', 'هشت ', 'نه '],
    dahgan = ['بیست ', 'سی ', 'چهل ', 'پنجاه ', 'شصت ', 'هفتاد ', 'هشتاد ', 'نود '],
    sadgan = [
      'یکصد ',
      'دویست ',
      'سیصد ',
      'چهارصد ',
      'پانصد ',
      'ششصد ',
      'هفتصد ',
      'هشتصد ',
      'نهصد ',
    ],
    dah = [
      'ده ',
      'یازده ',
      'دوازده ',
      'سیزده ',
      'چهارده ',
      'پانزده ',
      'شانزده ',
      'هفده ',
      'هیجده ',
      'نوزده ',
    ]
  if (level > 0) {
    result += ' و '
    level -= 1
  }

  if (num < 10) {
    result += yekan[num - 1]
  } else if (num < 20) {
    result += dah[num - 10]
  } else if (num < 100) {
    result += dahgan[parseInt(num / 10, 10) - 2] + wordifyfa(num % 10, level + 1)
  } else if (num < 1000) {
    result += sadgan[parseInt(num / 100, 10) - 1] + wordifyfa(num % 100, level + 1)
  } else if (num < 1000000) {
    result +=
      wordifyfa(parseInt(num / 1000, 10), level) +
      'هزار ' +
      wordifyfa(num % 1000, level + 1)
  } else if (num < 1000000000) {
    result +=
      wordifyfa(parseInt(num / 1000000, 10), level) +
      'میلیون ' +
      wordifyfa(num % 1000000, level + 1)
  } else if (num < 1000000000000) {
    result +=
      wordifyfa(parseInt(num / 1000000000, 10), level) +
      'میلیارد ' +
      wordifyfa(num % 1000000000, level + 1)
  } else if (num < 1000000000000000) {
    result +=
      wordifyfa(parseInt(num / 1000000000000, 10), level) +
      'تریلیارد ' +
      wordifyfa(num % 1000000000000, level + 1)
  }
  return result
}

export const PriceWithWords = ({ children }) => (
  <span>
    {!!children && <Price>{children}</Price>}
    {!!children ? (
      <span>{` (${wordifyfa(children)}تومان)`}</span>
    ) : (
      <span>صفر تومان</span>
    )}
  </span>
)

export const covertNumToPrice = number => {
  return number && `${toPersianDigit(formattedPrice(number))} تومان`
}

export function debounce(func, wait, immediate) {
  var timeout
  return function() {
    var context = this,
      args = arguments
    var later = function() {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export const reverseString = string =>
  string
    .split('')
    .reverse()
    .join('')

export const ensureEnglishNumber = text => {
  if (typeof text === 'string') {
    return text
      .split('')
      .map(perToEngMapper)
      .filter(char => !!char)
      .join('')
  } else {
    return ''
  }
}

// last one is dot for floating point numbers
var persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '.']
var english = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.']

const perToEngMapper = char => {
  if (english.indexOf(char) !== -1 && persian.indexOf(char) !== -1) {
    // return null if it is neither persian nor english number
    // because it a alphabetic char
    return null
  } else if (persian.indexOf(char) !== -1) {
    return english[persian.indexOf(char)]
  } else if (english.indexOf(char) !== -1) {
    return char
  }
}

export const uniq = arrArg => {
  return arrArg.filter((elem, pos, arr) => {
    return arr.indexOf(elem) === pos
  })
}

export const redirectToExternalLink = url => {
  if (!url) return

  const linkElement = document.createElement('a')
  linkElement.setAttribute('href', url)
  linkElement.setAttribute('target', '_blank')

  linkElement.click()
}

export function replaceLastInstance(string, charToReplace, Replacement) {
  return reverseString(reverseString(string).replace(charToReplace, Replacement))
}

export const promised = (fn, ...args) =>
  new Promise((resolve, reject) => {
    fn(...args, { resolve, reject })
  })

const piper = (a, b) => arg => b(a(arg))
export const pipe = (...ops) => ops.reduce(piper)

export const withLog = fn => (...args) => {
  if (settings.DEV_MODE) args.forEach(console.log)
  fn(...args)
}

export const branch = (test, ComponentOnPass, ComponentOnFail) => props =>
  test(props) ? (
    <ComponentOnPass {...props} />
  ) : ComponentOnFail ? (
    <ComponentOnFail {...props} />
  ) : null

export const showAllServerErrorsAsNotifications = withLog(
  ({ form_errors = {}, general_errors = [] } = {}) => {
    const flattenedErrors = [...flattenArray(general_errors), ...getErrors(form_errors)]

    for (let error of flattenedErrors) {
      NotificationManager.error(error)
    }
  }
)


export const createFormData = formObject => {
  let formData = new FormData()
  // appendToFormData2(formObject, formData)
  formData = appendToFormData2(formObject)
  return formData
}

function appendToFormData2(formObject) {
  const filterList = [null, undefined, '']
  let formData = new FormData()

  for (const field in formObject) {
    const fieldValue = formObject[field]

    const fieldType = typeof fieldValue
    const isFileList = fieldValue instanceof FileList

    if (!filterList.includes(fieldValue)) {
      if (fieldType === 'object') {
        if (isFileList) {
          // it's a file
          formData.append(field, fieldValue[0])
        } else {
          // it's an object
          formData.append(field, JSON.stringify(fieldValue))
        }
      } else {
        // it's not an object nor an array
        formData.append(field, fieldValue)
      }
    }
  }
  return formData
}

export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

export const isImageUrl = (urlString) => {
  const url = urlString.replace(/\/$/, '') /* remove optional end / */
  const fileName = url.substr(url.lastIndexOf('/') + 1)

  return (/\.(gif|jpg|jpeg|tiff|png|webp)$/i).test(fileName)
}



// WEBPACK FOOTER //
// ./src/helpers/utility.js